import "./RecordItem.css";
import { IRecord } from "../../interfaces/interfaces";
import { deleteRecordInDb } from "../../controllers/deleteRecord";
import { useRecords } from "../../hooks/useRecords";
interface props {
  record: IRecord;
  setEditPopUp: any;
}

const RecordItem = ({ record, setEditPopUp }: props) => {
  const { deleteRecord, addDeletedRecord, addEditForm } = useRecords();
  const deleteOneRecord = (_id: string) => {
    if (window.confirm("Do you want to delete this record?")) {
      deleteRecordInDb(_id)
        .then((deletedRecord) => {
          if (deletedRecord) {
            window.alert("The record was deleted");
            deleteRecord(deletedRecord);
            addDeletedRecord(deletedRecord);
          } else {
            window.alert("The record was not deleted");
          }
        })
        .catch((err) => err);
    }
  };

  const addToForm = (record: IRecord) => {
    addEditForm(record);
    setEditPopUp(true);
  };

  return (
    <div className="Item-box">
      <div className="Item-middle-box-one">
        <p>
          <b>Nombre:</b> {record.name}
        </p>
        <p>
          <b>Teléfono:</b> {record.phone}
        </p>
      </div>
      <div className="Item-middle-box-two">
        <p>
          <b>Email:</b> {record.email}
        </p>
        <p>
          <b>Ingresado:</b> {record.date}
        </p>
      </div>
      <div className="Item-middle-box-three">
        <button className="Edit-button" onClick={() => addToForm(record)}>
          E
        </button>
        <button
          className="Delete-button"
          onClick={() => deleteOneRecord(record._id)}
        >
          D
        </button>
      </div>
    </div>
  );
};
export default RecordItem;
